import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from './firebase';
import { buildConversationList, computeUnreadState } from './messagingState';

export function useUnreadMessages(user) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadConversationIds, setUnreadConversationIds] = useState(() => new Set());

  useEffect(() => {
    if (!user?.uid) {
      setUnreadCount(0);
      setUnreadConversationIds(new Set());
      return undefined;
    }

    let messageDocs = [];
    let conversationReads = {};

    const recompute = () => {
      const conversations = buildConversationList(messageDocs, user.uid);
      const { unreadCount: count, unreadConversationIds: unreadIds } = computeUnreadState(
        conversations,
        conversationReads,
        user.uid
      );
      setUnreadCount(count);
      setUnreadConversationIds(unreadIds);
    };

    const messagesQuery = query(
      collection(db, 'messages'),
      where('participants', 'array-contains', user.uid)
    );

    const readsQuery = collection(db, 'users', user.uid, 'conversationReads');

    const unsubscribeMessages = onSnapshot(messagesQuery, (snapshot) => {
      messageDocs = snapshot.docs;
      recompute();
    }, (error) => {
      console.error('Unread messages listener error:', error);
    });

    const unsubscribeReads = onSnapshot(readsQuery, (snapshot) => {
      conversationReads = {};
      snapshot.docs.forEach((readDoc) => {
        conversationReads[readDoc.id] = readDoc.data();
      });
      recompute();
    }, (error) => {
      console.error('Conversation reads listener error:', error);
    });

    return () => {
      unsubscribeMessages();
      unsubscribeReads();
    };
  }, [user?.uid]);

  return { unreadCount, unreadConversationIds };
}